import { getJson } from '@/api/http';

export const getGroupList = (liveId,token) => getJson(`${config.cppm}monitor/v2/webcast/group_info/list/${liveId}`,null,{token})

export const getGroupUsers = (id,params,token) => getJson(`${config.cppm}monitor/v2/webcast/group_user/${id}`,params,{token})


